/* V57 — same keyed image-swap pattern as cladding; no cart or routing mutations. */
(() => {
  if (window.VigoDeckingVisualiserV57) {
    window.VigoDeckingVisualiserV57.scan(document);
    return;
  }
  const selector = '[data-vigo-decking-visualiser]';
  const instances = new WeakMap();
  const safeURL = value => {
    if (typeof value !== 'string' || !value) return '';
    try { const url = new URL(value, location.href); return /^(https?:)$/.test(url.protocol) ? url.href : ''; }
    catch (_) { return ''; }
  };
  const loadImage = src => new Promise(resolve => {
    if (!src) { resolve(false); return; }
    const image = new Image();
    let complete = false;
    const done = ok => {
      if (complete) return;
      complete = true;
      clearTimeout(timer);
      image.onload = image.onerror = null;
      resolve(ok);
    };
    const timer = setTimeout(() => done(false), 12000);
    image.onload = () => done(image.naturalWidth > 0);
    image.onerror = () => done(false);
    image.src = src;
    if (image.complete && image.naturalWidth) done(true);
  });
  const init = root => {
    if (instances.has(root)) return;
    const status = root.querySelector('[data-deck-status]');
    let raw;
    try { raw = JSON.parse(root.querySelector('[data-deck-data]').textContent); }
    catch (_) { if (status) status.textContent = 'Finish previews are unavailable. You can still view and buy the product above.'; return; }
    const entries = Object.entries(raw).filter(([, item]) => item && typeof item.colour === 'string' && typeof item.handle === 'string');
    const data = new Map(entries);
    if (!entries.length) return;
    const find = name => root.querySelector(`[data-deck-${name}]`);
    const content = find('content'), hero = find('hero'), room = find('room'), sample = find('product'), groups = find('groups');
    if (!content || !hero || !room || !sample || !groups || !status) return;
    let request = 0;
    let selected = '';
    const buttons = new Map();
    const groupNodes = new Map();
    const setText = (name, value) => { const node = find(name); if (node) node.textContent = value || ''; };
    const revealImage = (node, src, alt, ok) => {
      node.hidden = !ok;
      node.alt = alt;
      if (ok) node.src = src;
      else node.removeAttribute('src');
    };
    const select = async key => {
      if (!data.has(key)) return;
      selected = key;
      const item = data.get(key);
      const token = ++request;
      root.dataset.selectedKey = key;
      hero.classList.add('is-loading');
      hero.setAttribute('aria-busy', 'true');
      room.hidden = sample.hidden = true;
      find('empty').hidden = find('product-empty').hidden = true;
      setText('colour', item.colour);
      setText('series', item.series);
      setText('detail-colour', item.colour);
      setText('badge', item.series);
      setText('description', item.description || 'Compare the illustrated garden with the product photograph, then view this board for full specifications and ordering.');
      ['width', 'depth', 'length'].forEach(name => setText(name, item[name] || 'See product'));
      setText('availability', item.available ? 'Available to order' : 'Currently sold out');
      const link = find('link');
      const productURL = safeURL(item.url);
      link.hidden = !productURL;
      if (productURL) link.href = productURL;
      else link.removeAttribute('href');
      link.setAttribute('aria-label', `View ${item.colour} ${item.series} decking product`);
      setText('scene-note', item.hasScene ? 'Illustrative garden preview' : 'Product photograph · garden preview coming soon');
      hero.classList.toggle('is-product-preview', !item.hasScene);
      buttons.forEach((button, buttonKey) => {
        const active = buttonKey === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      status.textContent = `Loading ${item.colour}, ${item.series}…`;
      const roomURL = safeURL(item.room), sampleURL = safeURL(item.product);
      const [roomOK, sampleOK] = await Promise.all([loadImage(roomURL), loadImage(sampleURL)]);
      // A slower previous request must never overwrite the newest selection.
      if (token !== request || !root.isConnected) return;
      revealImage(room, roomURL, `${item.colour} ${item.series} decking ${item.hasScene ? 'illustrative garden preview' : 'product photograph'}`, roomOK);
      revealImage(sample, sampleURL, `${item.colour} ${item.series} decking product photograph`, sampleOK);
      find('empty').hidden = roomOK;
      find('product-empty').hidden = sampleOK;
      hero.classList.remove('is-loading');
      hero.setAttribute('aria-busy', 'false');
      status.textContent = `${item.colour}, ${item.series} selected.${roomOK ? '' : ' Garden image could not load; choose the finish again to retry.'}${sampleOK ? '' : ' Product image could not load.'}${item.handle === root.dataset.currentHandle ? '' : ' Previewing another product; use View this decking for its details.'}`;
    };
    entries.forEach(([key, item]) => {
      const groupName = item.group || 'More finishes';
      let options = groupNodes.get(groupName);
      if (!options) {
        const group = document.createElement('div');
        group.className = 'vigo-decking-vis__group';
        const title = document.createElement('h4');
        title.className = 'vigo-decking-vis__group-title';
        title.textContent = groupName;
        options = document.createElement('div');
        options.className = 'vigo-decking-vis__options';
        options.setAttribute('role', 'group');
        options.setAttribute('aria-label', groupName);
        group.append(title, options); groups.append(group); groupNodes.set(groupName, options);
      }
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vigo-decking-vis__finish';
      button.dataset.deckKey = key;
      button.setAttribute('aria-label', `${item.colour}, ${item.series}, ${[item.width, item.depth, item.length].filter(Boolean).join(' by ')}${item.available ? '' : ', sold out'}`);
      button.setAttribute('aria-pressed', 'false');
      const tick = document.createElement('span'); tick.className = 'vigo-decking-vis__tick'; tick.setAttribute('aria-hidden', 'true');
      const image = document.createElement('img'); image.alt = ''; image.loading = 'lazy'; image.decoding = 'async'; image.width = image.height = 240;
      const thumb = safeURL(item.thumb || item.product);
      if (thumb) image.src = thumb;
      else image.hidden = true;
      image.addEventListener('error', () => { image.hidden = true; });
      const label = document.createElement('span'); label.className = 'vigo-decking-vis__finish-label'; label.textContent = item.colour;
      const series = document.createElement('small'); series.className = 'vigo-decking-vis__finish-series'; series.textContent = item.series;
      const dimensions = document.createElement('small'); dimensions.className = 'vigo-decking-vis__finish-dimensions'; dimensions.textContent = [item.width, item.depth, item.length].filter(Boolean).join(' × ');
      button.append(tick, image, label, series, dimensions);
      button.addEventListener('click', () => select(key));
      options.append(button); buttons.set(key, button);
    });
    instances.set(root, { select, destroy: () => { request++; instances.delete(root); }, selected: () => selected });
    content.hidden = false;
    select(data.has(root.dataset.defaultKey) ? root.dataset.defaultKey : entries[0][0]);
  };
  const scan = scope => {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll(selector).forEach(init);
  };
  window.VigoDeckingVisualiserV57 = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(root => instances.get(root)?.destroy());
  });
  document.addEventListener('shopify:block:select', event => {
    const key = event.detail?.blockId;
    if (!key) return;
    document.querySelectorAll(selector).forEach(root => {
      if ([...root.querySelectorAll('[data-deck-editor-block]')].some(node => node.dataset.deckEditorBlock === key)) instances.get(root)?.select(key);
    });
  });
})();
